define("shared/components/shared/card", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--card" ...attributes>
    {{yield
      (hash
        header=(component "shared/card/header")
        body=(component "shared/card/body")
        card=(component "shared/card")
        footer=(component "shared/card/footer")
      )
    }}
  </div>
  */
  {
    "id": "cAGOUCgA",
    "block": "[[[11,0],[24,0,\"o--card\"],[17,1],[12],[1,\"\\n  \"],[18,2,[[28,[37,1],null,[[\"header\",\"body\",\"card\",\"footer\"],[[50,\"shared/card/header\",0,null,null],[50,\"shared/card/body\",0,null,null],[50,\"shared/card\",0,null,null],[50,\"shared/card/footer\",0,null,null]]]]]],[1,\"\\n\"],[13]],[\"&attrs\",\"&default\"],false,[\"yield\",\"hash\",\"component\"]]",
    "moduleName": "shared/components/shared/card.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});